var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgButtonPlayCircleBlack = function SvgButtonPlayCircleBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 8,
    fill: "#151515"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 30C23.732 30 30 23.732 30 16C30 8.26802 23.732 2 16 2C8.26802 2 2 8.26802 2 16C2 23.732 8.26802 30 16 30ZM13.53 10.152C13.2217 9.95934 12.8332 9.94914 12.5152 10.1254C12.1973 10.3016 12 10.6365 12 11V21C12 21.3635 12.1973 21.6984 12.5152 21.8746C12.8332 22.0508 13.2217 22.0406 13.53 21.848L21.53 16.848C21.8224 16.6653 22 16.3448 22 16C22 15.6552 21.8224 15.3347 21.53 15.152L13.53 10.152Z",
    fill: "#AE966B"
  })));
};
export default SvgButtonPlayCircleBlack;